module.exports = __webpack_public_path__ + "static/media/shadow.06292d72.svg";